export default "__VITE_ASSET__BhQOFWHc__"